export const NAME = 'searchExtend';